module.exports = __webpack_public_path__ + "img/120.7fe3914a.png";